import * as VanillaSharing from 'vanilla-sharing';
import meta from '../data/meta.json';
import { removeDoubleSlashes } from './utils/removeDoubleSlashes';
import YmSendGoal from './helpers/YmSendGoal';

export const createOptions = (options = {}) => {
    const {
        url = `${meta.url}${meta.base}`,
        title = meta.title,
        description = meta.description,
        shareImage = meta.shareImage,
        fbappid: fbAppId = meta.fbappid,
        isVkParse = false
    } = options;

    return {
        url,
        title,
        description,
        image: removeDoubleSlashes(`${meta.url}${meta.base}${shareImage}`),
        media: removeDoubleSlashes(`${meta.url}${meta.base}${shareImage}`),
        isVkParse,
        fbAppId
    };
};

// Encapsulates the way of sharing
export const share = (social, options) => {
    console.log(options);
    VanillaSharing[social](options);
};

const registerListener = (buttonNodeElement, options) => {
    const { social } = buttonNodeElement.dataset;

    buttonNodeElement.addEventListener('click', () => {
        share(social, options);

        YmSendGoal(social.toUpperCase());
    });
};

export const initShareButtons = (selector, options = {}) => {
    const buttons = [...document.querySelectorAll(selector || '.share__item')];

    if (buttons.length > 0) {
        const finOptions = createOptions(options);

        buttons.forEach((button) => {
            registerListener(button, finOptions);
        });
    }
};
